import { Component, OnInit, Input, TemplateRef, ContentChild } from '@angular/core';


@Component({
    'selector': 'ciee-labeledControl',
    'templateUrl': './labeled-control.component.html',
    standalone: false
})
export class LabeledControlComponent {
  @Input() label: string;
  @Input() externalClass: String = '';
  @Input() required: boolean = false;
  @Input() helpText: string = '';
}
